module.exports = __webpack_public_path__ + "img/monitoreo.1447ceb2.svg";